export const meta = {
  pricing: {
    title: 'Loudly API Pricing – AI Music Generator API Plans for Developers',
    description:
      'Explore Loudly’s AI Music Generator API pricing. Flexible plans for developers to integrate text-to-music, soundtracks, and AI-powered audio creation into apps, games, and platforms.',
  },
  apiView: {
    title:
      'Loudly API Playground – Try AI Music Generator & Text-to-Music Endpoints',
    description:
      'Test the Loudly API in the interactive Playground. Generate AI music from text, experiment with audio endpoints, and explore developer-friendly documentation for seamless integration.',
  },
  myApps: {
    title: 'Loudly API – Manage Apps, API Keys & Usage for AI Music Generator',
    description:
      'Access your Loudly API dashboard to manage apps, generate and secure API keys, and monitor usage.',
  },
};
